import React from 'react';

export const WhyUs = () => {
  const roadmap = [
    { icon: 'solar:crown-star-linear', label: 'LEADERBOARDS', status: 'COMING SOON' },
    { icon: 'solar:palette-linear', label: 'CUSTOM DOMINO SKINS & TABLES', status: 'IN DESIGN' },
    { icon: 'solar:cup-star-bold', label: 'COMPETITIVE MODES & REWARDS', status: 'PLANNED' },
    { icon: 'solar:global-linear', label: 'GLOBAL RANKINGS', status: 'PLANNED' },
  ];

  const others = ['Basic gameplay only', 'Repetitive & boring', 'Poorly designed UI', 'Zero customization', 'Outdated feel'];
  const ours = ['Advanced rule customization', 'Competitive-focused gameplay', 'Clean, high-end design', 'Built for long-term evolution', 'Premium visual experience'];

  return (
    <section className="relative bg-black text-white py-24 overflow-hidden border-t-8 border-yellow-400">
      <div className="absolute inset-0 bg-halftone opacity-5 pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">

        {/* What Makes Us Different */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <div className="inline-block bg-red-600 text-white px-6 py-2 font-anton text-sm tracking-widest uppercase transform skew-x-3 mb-4 shadow-[4px_4px_0px_#eab308]">
              🚀 WHAT MAKES US DIFFERENT
            </div>
            <h2 className="font-anton text-6xl md:text-8xl uppercase transform rotate-1">
              BUILT <span className="text-yellow-400">DIFFERENT</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Others */}
            <div className="bg-neutral-900 border-2 border-gray-700 p-6 transform -rotate-1 opacity-70">
              <h3 className="font-anton text-2xl text-gray-500 mb-6 line-through uppercase">Basic Domino Apps</h3>
              <ul className="space-y-3">
                {others.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-gray-500 font-sans">
                    <span className="text-red-600 text-xl font-bold">✗</span> {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* Us */}
            <div className="bg-yellow-400 text-black border-4 border-black p-6 transform rotate-1 shadow-[8px_8px_0px_#ffffff]">
              <h3 className="font-anton text-2xl text-black mb-6 uppercase">Cutthroat Dominoes Master</h3>
              <ul className="space-y-3">
                {ours.map((item, i) => (
                  <li key={i} className="flex items-center gap-3 text-black font-sans font-semibold">
                    <span className="text-black text-xl font-bold">✔</span> {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Roadmap */}
        <div>
          <div className="mb-12">
            <div className="inline-block bg-white text-black px-6 py-2 font-anton text-sm tracking-widest uppercase transform -skew-x-6 mb-4 shadow-[4px_4px_0px_#eab308]">
              🏆 FUTURE ROADMAP
            </div>
            <h2 className="font-anton text-6xl md:text-7xl uppercase transform -rotate-1 leading-none mb-4">
              WE'RE JUST <br /><span className="text-yellow-400">GETTING</span> STARTED
            </h2>
            <p className="font-marker text-gray-400 text-xl">We're building a dominoes ecosystem, not just a game.</p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {roadmap.map((item, i) => (
              <div key={i} className={`flex items-center gap-4 bg-neutral-900 border-2 border-gray-700 p-4 transform ${i % 2 === 0 ? '-skew-x-2' : 'skew-x-2'} hover:border-yellow-400 hover:translate-x-1 transition-all duration-300 group`}>
                <div className="w-12 h-12 bg-yellow-400 flex items-center justify-center flex-shrink-0 group-hover:bg-white transition-colors">
                  <iconify-icon icon={item.icon} width="28" className="text-black"></iconify-icon>
                </div>
                <div className="flex-1 font-anton text-xl">{item.label}</div>
                <div className="bg-black border border-gray-700 text-yellow-400 text-xs font-bold uppercase px-3 py-1 tracking-widest whitespace-nowrap group-hover:border-yellow-400 transition-colors">
                  {item.status}
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};
